{
  "Panel Email": "E-mail Paneel",
  "directadmin_email": {
    "0 = Sınırsız": "0 = Onbeperkt",
    "Disk Kullanımı": "Schijfgebruik",
    "Doluluk (%)": "Bezetting (%)",
    "E-posta Adresi": "E-mailadres",
    "E-posta Hesapları": "E-mailaccounts",
    "E-posta hesabı oluşturuldu": "E-mailaccount aangemaakt.",
    "En az 6 karakter": "Minimaal 6 tekens",
    "Hesap silindi": "Account verwijderd.",
    "Hiç e-posta hesabı bulunamadı": "Geen e-mailaccount gevonden.",
    "Kota (0 = Sınırsız)": "Quota (0 = Onbeperkt)",
    "Kota (MB)": "Quota (MB)",
    "Kota Düzenle": "Quota bewerken",
    "Kota Limiti (MB)": "Quota Limiet (MB)",
    "Kota güncellendi": "Quota bijgewerkt.",
    "Kullanıcı Adı": "Gebruikersnaam",
    "Kullanım (MB)": "Gebruik (MB)",
    "Limit (MB)": "Limiet (MB)",
    "Panel Email": "E-mail Paneel",
    "Silme işlemi başarısız": "Verwijderen mislukt.",
    "Yeni E-posta Hesabı": "Nieuw E-mailaccount",
    "Yeni Hesap": "Nieuw Account",
    "hesabı kalıcı olarak silinecek!": "account wordt permanent verwijderd!",
    "için Yeni Şifre": "Nieuw wachtwoord voor",
    "orn: info": "bijv: info",
    "Şifre başarıyla değiştirildi": "Wachtwoord succesvol gewijzigd.",
    "Şifre en az 6 karakter olmalıdır": "Wachtwoord moet minimaal 6 tekens bevatten",
    "Bir hata oluştu": "Bir hata oluştu.",
    "Excel hatası: ": "Excel fout: ",
    "Kullanıcı": "Gebruiker",
    "Şifre Değiştir": "Wachtwoord Wijzigen",
    "Sil": "Verwijderen",
    "İptal": "Annuleren",
    "Kaydet": "Opslaan",
    "Oluştur": "Aanmaken",
    "Silme Onayı": "Verwijder Bevestiging",
    "Hayır": "Nee",
    "Evet, Sil": "Ja, Verwijderen",
    "Değiştir": "Wijzigen",
    "ExceleAktar": "Exporteren naar Excel",
    "Yükleniyor": "Laden...",
    "Şifre": "Wachtwoord",
    "Yeni Şifre": "Nieuw Wachtwoord",
    "Güncelle": "Bijwerken",
    "Emin misiniz?": "Weet u het zeker?",
    "Hata oluştu": "Fout opgetreden",
    "İşlemler": "Acties"
  }
}
